var React = require('react');

var VisCircle = React.createClass({
    render : function(){
        var percent = this.props.percent && this.props.percent.length ? this.props.percent : [0,0];
        var rotationAngle = Math.round(360 * (percent[0] / 100));
        var colors = this.props.colors || ['#ffc300', "#d31346"];
        var teamColor = this.props.home ? colors[0] : colors[1];
        var backgroundColor = "#e5e5e5";
        
        return (
            <div className="data-chart" data-chart={this.props.home ? "1" : "2"} style={{"width":"135px", "height":"135px"}}>
                <div className="outer-circle">
                    <div data-wedge-id="a" className="wedge-container" style={{transform: "rotate(0deg)", WebkitTransform: "rotate(0deg)", clip: "auto", msTransform: "rotate(0deg)"}}>
                        <div className="wedge" style={{msTransform: "rotate(" + rotationAngle + "deg)", WebkitTransform: "rotate(" + rotationAngle + "deg)", transform: "rotate(" + rotationAngle + "deg)", clip: "rect(0px 73px 150px 0px)", backgroundColor: rotationAngle < 180 ? backgroundColor : teamColor}}></div>
                        <div className="wedge-extension" style={{opacity: 1, msTransform: "rotate(180deg)", WebkitTransform: "rotate(180deg)", transform: "rotate(180deg)", clip: "rect(0px 75px 150px 0px)", backgroundColor: rotationAngle < 180 ? backgroundColor : teamColor}}></div>
                    </div>
                    <div data-wedge-id="b" className="wedge-container" style={{msTransform: "rotate(" + rotationAngle + "deg)", WebkitTransform: "rotate(" + rotationAngle + "deg)", transform: "rotate(" + rotationAngle + "deg)", clip: "rect(0px 150px 150px 75px)"}}>
                        <div className="wedge" style={{msTransform: "rotate(" + (360 - rotationAngle) + "deg)", WebkitTransform: "rotate(" + (360 - rotationAngle) + "deg)", transform: "rotate(" + (360 - rotationAngle) + "deg)", clip: "rect(0px 73px 150px 0px)", backgroundColor: rotationAngle < 180 ? teamColor : backgroundColor}}></div>
                        <div className="wedge-extension" style={{"opacity": "0"}}></div>
                    </div>
                </div>
                
                <div className="inner-circle">
                    <span className="team-logo"></span>
                    <span className="team-name"></span>
                    <span className="home-team">{this.props.value}</span>
                    <span className="away-team">{percent[0] + '%'}</span>
                </div>
            </div>
        );
    }
});

module.exports = VisCircle;


/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/rugby/game/VisCircle.jsx
 **/